import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BEGIN = (
    <FormattedMessage
        id='battle_log.battle_begin'
        defaultMessage='Начало'
    />
)

export const SERVER = (
    <FormattedMessage
        id='battle_log.battle_server'
        defaultMessage='Сервер'
    />
)

export const PROVINCE = (
    <FormattedMessage
        id='battle_log.battle_province'
        defaultMessage='Провинция'
    />
)

export const MAP = (
    <FormattedMessage
        id='battle_log.battle_map'
        defaultMessage='Карта'
    />
)

export const BASE = (
    <FormattedMessage
        id='battle_log.base'
        defaultMessage='Место высадки'
    />
)

export const ENEMY = (
    <FormattedMessage
        id='battle_log.battle_enemy'
        defaultMessage='Противник'
    />
)

export const ENEMY_NOT_DEFINED = (
    <FormattedMessage
        id='battle_log.battle_enemy_not_defined'
        defaultMessage='Противник не определён'
    />
)

export const NO_CLAN_BATTLES = (
    <FormattedMessage
        id='battle_log.no_clan_battles'
        defaultMessage='У вашего клана нет боёв'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXBattleSchedule/components/BattleLog/translations.jsx